import React, { useEffect } from "react";
import useCouponHook from "../../hook/useCouponHook";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";
import { useSelector, useDispatch } from "react-redux";
import { couponCheck } from "../../utils/redux/slices/checkoutSlice";

const Price = ({ activeForm, selectedPayment, disabled, setCouponApply }) => {
  const couponValidate = useSelector((state) => state?.checkout?.coupon);
  const priceRTK = useSelector((state) => state?.checkout?.price);
  const newPriceRTK = useSelector((state) => state?.checkout?.newPrice);
  const { coupon, setCoupon, correctCoupon, price, newPrice } = useCouponHook();

  const dispatch = useDispatch();

  useEffect(() => {
  }, [price, newPrice]);

  const handleCouponChange = (event) => {
    console.log("coupon", event.target.value);
    setCoupon(event.target.value);
    setCouponApply(event.target.value)
  };

  const handleApplyCoupon = (e) => {
    e.preventDefault();
    const data = {
      data: {
        coupon: coupon,
      },
    };

    dispatch(couponCheck(data));
  };

  return (
    <>
      <div className="flex flex-col md:flex-row justify-around items-center p-3 mt-3">
        {selectedPayment === "CREDITCARD" &&
        couponValidate?.data?.success === true ? (
          <>✅ Coupon successfully applied!</>
        ) : selectedPayment === "CREDITCARD" &&
          correctCoupon === false &&
          activeForm === true ? (
          <div className="flex gap-2 items-end">
            <div>
              <Label className="label-Input-form">Coupon</Label>
              <Input
                value={coupon}
                onChange={handleCouponChange}
                disabled={disabled}
              />
            </div>
            <div>
              <Button
                className="mx-auto font-general hover:bg-gray-600"
                onClick={handleApplyCoupon}
                disabled={disabled}
              >
                Apply
              </Button>
            </div>
          </div>
        ) : null}

        <div className=" flex flex-col text-right">
          <div className="text-bold font-general text-lg text-black">
            TOTAL:
          </div>{" "}
          <div className="text-general font-general text-lg">
            {selectedPayment === "CREDITCARD" ? (
              <>€ {(newPriceRTK || newPriceRTK === 0) ? newPriceRTK : priceRTK}</>
            ) : (
              <>€ {priceRTK}</>
            )}
          </div>{" "}
        </div>
      </div>
      <div className="m-4">
        {couponValidate && couponValidate.error && (
          <div>❌ Invalid coupon!</div>
        )}
      </div>
    </>
  );
};

export default Price;
